import type { HoldChallengeUnionType } from 'src/api/generated/touring/types/holdChallengeUnionType';
import { Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import styles from './ChallengeStatus.module.css';

type ChallengeStatusPropsType = {
  challenge: HoldChallengeUnionType;
};

export const ChallengeStatus: React.FC<ChallengeStatusPropsType> = ({
  challenge,
}) => {
  const { t } = useTranslation('common');

  const className = challenge === 'WON' ? 'challenge-won' : 'challenge-lost';
  const labelKey =
    challenge === 'WON' ? 'HOLD_CHALLENGE.WON' : 'HOLD_CHALLENGE.LOST';

  return (
    <Text className={styles[className]}>{t(labelKey)}</Text>
  );
};
